<template>
  <div class="bottom">
    <div class="auto">
      <div class="bottom-bottom ytable">
        <div class="bottom-bottom-logo">
          <img src="../assets/logo_2@2x.png" :alt="lan === 0 ? '春阳台 logo' : 'Chun Yang Tai logo'" />
        </div>
        <div class="content ytable-cell">
          <div class="links">
            <span>
              <router-link :to="{ name: 'visitor', query: { columnId: 6 } }">
                {{ lan === 0 ? '联系我们' : 'Contact Us' }}
              </router-link>
            </span>
          </div>
          <div class="copyright" v-if="lan === 0">
            <div>地址：广州市花都区炭步镇朗头村青云路18号</div>
            <div>电话：020-22262888</div>
            <div>邮箱：
              <a href="mailto:chunyangtai@langchuanculture.cn" class="email-link">chunyangtai@langchuanculture.cn</a>
            </div>
          </div>
          <div class="copyright" v-else>
            <div>Add: NO.18 Qingyun Road, Langtou Village,Tanbu Town, Huadu District, Guangzhou, China</div>
            <div>Tel: 020-22262888</div>
            <div>Email: 
              <a href="mailto:chunyangtai@langchuanculture.cn" class="email-link">chunyangtai@langchuanculture.cn</a>
            </div>
          </div>
          <div class="bottom-certificate">
            <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">
              ©️2024 CHUN YANG TAI 粤ICP备2023112445号
            </a>
          </div>
        </div>
        <div class="bottom-bottom-right">
          <div class="links">
            <span>{{ lan === 0 ? '关注我们' : 'Contact Us' }}</span>
          </div>
          <div class="bottom-links-icon">
            <a href="http://www.youtube.com/@chunyangtai-langtou" target="_blank" 
               :title="lan === 0 ? '访问我们的 YouTube 频道' : 'Visit our YouTube channel'"
               :aria-label="lan === 0 ? 'YouTube' : 'YouTube'">
              <img src="../assets/youtube.png" :alt="lan === 0 ? 'YouTube' : 'YouTube'" />
            </a>
            <a href="https://www.instagram.com/langtou_chunyangtai?igsh=cmt5NzNuZGJ5Mm96&utm_source=qr" target="_blank"
               :title="lan === 0 ? '访问我们的 Instagram' : 'Visit our Instagram'"
               :aria-label="lan === 0 ? 'Instagram' : 'Instagram'">
              <img src="../assets/ins.png" :alt="lan === 0 ? 'Instagram' : 'Instagram'" />
            </a>
            
            <el-popover
              placement="top"
              title=""
              width="100"
              trigger="hover"
              content="">
              <img src="../assets/WeChatQRcode.jpg" :alt="lan === 0 ? '微信二维码' : 'WeChat QR Code'" />
              <img slot="reference" src="../assets/weixin@2x.png" :alt="lan === 0 ? '微信' : 'WeChat'" />
            </el-popover>
            
            <el-popover
              placement="top"
              title=""
              width="100"
              trigger="hover"
              content="">
              <img src="../assets/XiaohongshuQRcode.jpeg" :alt="lan === 0 ? '小红书二维码' : 'Xiaohongshu QR Code'" />
              <img slot="reference" src="../assets/xiaohonshu@2x.png" :alt="lan === 0 ? '小红书' : 'Xiaohongshu'" />
            </el-popover>
            
            <el-popover
              placement="top"
              title=""
              width="100"
              trigger="hover"
              content="">
              <img src="../assets/TiktokQRcode.jpg" :alt="lan === 0 ? '抖音二维码' : 'TikTok QR Code'" />
              <img slot="reference" src="../assets/douyin@2x.png" :alt="lan === 0 ? '抖音' : 'TikTok'" />
            </el-popover>
            
            <el-popover
              placement="top"
              title=""
              width="100"
              trigger="hover"
              content="">
              <img src="../assets/BilibiliQRcode.png" :alt="lan === 0 ? '哔哩哔哩二维码' : 'Bilibili QR Code'" />
              <img slot="reference" src="../assets/bilibili@2x.png" :alt="lan === 0 ? '哔哩哔哩' : 'Bilibili'" />
            </el-popover>
            
            <el-popover
              placement="top"
              title=""
              width="100"
              trigger="hover"
              content="">
              <img src="../assets/EnterpriseWeChatQRcode.jpg" :alt="lan === 0 ? '企业微信二维码' : 'Enterprise WeChat QR Code'" />
              <img slot="reference" src="../assets/qiyehao@2x.png" :alt="lan === 0 ? '企业微信' : 'Enterprise WeChat'" />
            </el-popover>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bottom",
  props: {
    Index: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"(newVal) {
      this.lan = newVal;
    },
  },
};
</script>

<style scoped>
.bottom {
  background-color: #000000;
  background-size: cover;
  min-width: 320px;
}

.bottom .bottom-bottom {
  width: 95%;
  height: 360px;
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  padding-top: 106px;
}

.bottom-bottom-logo {
  width: 105px;
  height: 44px;
}

.bottom .links,
.bottom .links a {
  font-size: 14px;
  color: #fff;
  font-weight: 700;
  font-family: SourceHanSansCN-Bold;
}

.bottom .links a {
  cursor: pointer;
  text-decoration: none;
}

.bottom .links a:hover {
  text-decoration: underline;
}

.bottom .links span:first-child a {
  margin-left: 0;
}

.bottom .copyright {
  padding-top: 1%;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #fff;
  line-height: 28px;
  font-weight: 400;
}

.bottom .copyright a {
  font-weight: 400;
  color: #E3B389;
  font-size: 14px;
  transition: all 0.3s ease-in-out;
}

.email-link {
  text-decoration: underline;
  color: #E3B389;
}

.email-link:hover {
  color: #E3B389;
}

.bottom-links-icon {
  display: flex;
  margin-top: 20px;
}

.bottom-links-icon img {
  width: 28px;
  height: 28px;
  margin-right: 12px;
}

.bottom-certificate {
  padding-top: 60px;
}

.bottom-certificate a {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #98989F;
  font-weight: normal;
  text-decoration: none;
}

.bottom-certificate a:hover {
  text-decoration: underline;
}

@media (max-width: 1440px) {
  .bottom .bottom-bottom {
    width: 93%;
  }
}

@media (max-width: 1200px) {
  .bottom .infor-box {
    padding-left: 0;
    float: none;
  }
  
  .bottom .qrcode {
    position: initial;
    width: 132px;
  }
  
  .bottom .qrcode .box {
    display: inline-block;
    width: 100%;
  }
}

@media (max-width: 1024px) {
  .bottom .fl dt a {
    font-size: 15px;
  }
  
  .bottom .fl dd a {
    font-size: 14px;
  }
  
  .bottom .entitle {
    font-size: 28px;
  }
}

@media (max-width: 960px) {
  .bottom .fl {
    display: none;
  }
  
  .bottom .fr {
    width: 100%;
  }
  
  .bottom .qrcode {
    margin: 0 auto;
  }
  
  .bottom .infor-box {
    float: none;
    text-align: center;
    padding-top: 1%;
  }
  
  .bottom .infor {
    padding-top: 1%;
  }
  
  .bottom .infor > div {
    padding: 1% 0;
  }
  
  .bottom .copyright {
    padding-right: 0;
  }
}

@media (max-width: 640px) {
  .bottom .share {
    width: 220px;
  }
  
  .bottom .title {
    font-size: 26px;
  }
  
  .bottom .entitle {
    line-height: 1.5;
    padding-top: 3%;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .bottom .bottom-logo.isIndex.en::after,
  .bottom .bottom-logo.isIndex::after {
    content: none;
  }
  
  .bottom .fr {
    text-align: center;
  }
  
  .bottom .qrcode .box {
    width: 96px;
    margin: 0 auto;
  }
  
  .bottom .qrcode .txt {
    padding: 3% 0;
  }
  
  .bottom .qrcode {
    margin: 10px auto;
  }
  
  .bottom-bottom {
    display: block;
  }
  
  .bottom .copyright {
    line-height: 1.5;
    padding: 1% 2%;
  }
  
  .bottom .copyright a {
    line-height: 1.5;
  }
  
  .bottom .share {
    float: none;
    margin: 0 0 0 auto;
    height: 80px;
  }
  
  .bottom .bottom-top {
    line-height: 80px;
  }
  
  .bottom .to-top.mar {
    position: initial;
    margin-top: 5%;
  }
  
  .bottom .content {
    text-align: center;
  }
  
  .bottom .title {
    width: 100%;
  }
  
  .bottom .entitle {
    font-size: 20px;
  }
  
  .bottom .links a {
    font-size: 12px;
  }
}
</style>
